import React from 'react'

interface SwitchProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    label?: string;
}

export const Switch: React.FC<SwitchProps> = ({ checked, onChange, label }) => {
    return (
        <div className="flex items-center">
            <button
                type="button"
                role="switch"
                aria-checked={checked}
                onClick={() => onChange(!checked)}
                className={`
          relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent 
          transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 
          focus-visible:ring-primary/50 focus-visible:ring-offset-2 ring-offset-app-bg
          ${checked ? 'bg-primary shadow-[inset_0_2px_4px_rgba(0,0,0,0.2)]' : 'bg-white/10 hover:bg-white/20'}
        `}
            >
                <span
                    className={`
            pointer-events-none block h-5 w-5 rounded-full bg-white shadow-lg ring-0 
            transition-transform duration-200 ease-in-out
            ${checked ? 'translate-x-5' : 'translate-x-0'}
          `}
                />
            </button>
            {label && <span className="ml-3 text-sm font-bold text-text">{label}</span>}
        </div>
    )
}
